// THIS IS SECURITY PAGE COMPONENT
//*******************************************************************
//*******************************************************************
//Importing Dependencies:
//external and package dependencies 
//import $ from 'jquery'
//import Popper from 'popper.js'
import React from 'react'
import { Link, graphql } from 'gatsby'
//component dependencies
import Heading from '../../components/heading'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer'
import PageHeader from '../../components/PageHeader'
import FullWidthImage from '../../components/FullWidthImage'
import TextBlock from '../../components/textblock'
import TableOfContents from '../../components/TableOfContents'
import ContentBlock from '../../components/ContentBlock'
import ContentList from '../../components/ContentList'
import SecurityIcon from '../../images/securityIcon.png'
import Helmet from "react-helmet"
//*******************************************************************
//*******************************************************************
class thisIsSecurityIndex extends React.Component {
    
    render() {
        
        const { data } = this.props
        
        const posts = data.allButterPost.edges
        
        const resultsTable = []
    
        for (var i = 0; i < 6; i++) {

            resultsTable.push(posts[i]);

        };
        
        
        
        const thisIsSecurity = data.this_is_security.edges
        
        return (      
        
        <div>
            <Helmet>
                   <title>NJCCIC This is Security</title>
                    <meta name="description" content="No-hype, practical security tips to help them better secure their networks and prevent cyber incidents."/>
            </Helmet>
        
            
        
            <Heading/>
            
            <Navbar/>
            
            {thisIsSecurity.map(( {node: {page_title, introductory_text, image, content_group} }) => (
                
                <div class="container-fluid">
        
                    <PageHeader divClass="containerWidth" elementClass="pageHeader centerText" title={page_title}/>
                        
                    <div class="container containerWidth">
                            
                        <div class="row">
        
                            <TextBlock elementClass="standardText introPadding alertsIntro btnWidth" text={introductory_text}/>
                            
                        </div>
                        
                        </div>
        
                    <FullWidthImage id="thisIsSecurityBanner" src={image}/>        
    
                </div>
                    
            ))}
                
            <div class="container-fluid">
                
                <div class="container containerWidth">
                    
                    <div class="row" id="getStarted">
                    
                        {resultsTable.map(({ node }) => {

                        const postTitle = node.seo_title || node.slug

                        const tag = node.tags

                            return (

                                <div class="col-12 col-sm-6 offset-sm-0 col-md-4 articleFeature" key={node.slug}>

                                    <img src={node.featured_image}></img>

                                    <h2 class="header leftHeader clickableHeader postHeader articleName"><Link to={`/this-is-security/${node.slug}`}>{postTitle}</Link></h2>

                                    <p>{node.summary}</p>

                                    <p class="fontWeight"><Link to={`/this-is-security/${node.slug}`}>CONTINUE READING > </Link></p>       

                                </div>

                            )

                        })} 
                        
                    </div>
                
                </div>
                
            </div> 
        
            <Footer/>       
            
        </div>  

    )}
}
export default thisIsSecurityIndex
//*******************************************************************
//*******************************************************************
export const pageQuery = graphql`
    query {
        allButterPost(filter: {categories: {elemMatch: {name: {eq: "This-Is-Security-Report"}}}}) {
            edges {
                node {
                    id
                    seo_title
                    meta_description
                    slug
                    categories {
                        name
                        slug
                    }
                    tags {
                        name
                        slug
                    }
                    date
                    summary
                    author {
                        first_name
                        last_name
                        email
                        slug
                        bio
                        title
                        linkedin_url
                        facebook_url
                        instagram_url
                        pinterest_url
                        twitter_handle
                        profile_image
                    }
                    body
                    featured_image
                }
            }
        }
        this_is_security: allButterPage(filter: { slug: { eq: "this-is-security" } }) {
            edges {
                node {
                    seo_title
                    page_title
                    introductory_text
                    image
                    image_alt_text
                    content_group {
                        section_name
                        text
                    }   
                }               
            }
        }
    }   
`
//******************************************************************* 